import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import "./SubMenu.scss";

export interface SubMenuItem {
  id: string;
  text: string;
  url: string;
  baseUrl?: string;
}

interface TopLinkSubMenuProps {
  id?: string;
  items: SubMenuItem[];
}

export const TopLinkSubMenu = ({ id, items }: TopLinkSubMenuProps) => {
  const { pathname } = useLocation();

  return (
    <div className="top-link-sub-menu">
      <div className="layout__container">
        <ul className="top-link-sub-menu__list" id={id}>
          {items.map((item) => (
            <li className="top-link-sub-menu__item" key={item.id}>
              <NavLink
                className={({ isActive }) =>
                  classnames("top-link-sub-menu__link", {
                    active: isActive || pathname.includes(item.baseUrl),
                  })
                }
                to={item.url}
              >
                <FormattedMessage id={item.text} />
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

interface SubMenuDropdownProps {
  id: string;
  subMenu: SubMenuItem[];
  isOpen: boolean;
}

export const SubMenuDropdown = ({
  id,
  subMenu,
  isOpen,
}: SubMenuDropdownProps) => {
  return (
    <ul
      id={id}
      className={classnames("sub-menu-dropdown", {
        "sub-menu-dropdown--expanded": isOpen,
      })}
    >
      {subMenu.map((submenuItem) => (
        <li className="sub-menu-dropdown__item" key={submenuItem.id}>
          <NavLink className="sub-menu-dropdown__link" to={submenuItem.url}>
            <FormattedMessage id={submenuItem.text} />
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
